import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { LanHealthComponent } from '@app/features/lan/modules/lan-health/lan-health.component';
import { Authority } from '@app/shared/utils/enums';

export const lanRoutes: Routes = [
    {
        path: 'lan',
        children: [
            {
                path: '',
                component: LanHealthComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.LOGIN, Authority.RESTAURANT_VIEW, Authority.HELP_1, Authority.UPDATE],
                    reuse: true
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]